module.exports = __webpack_public_path__ + "static/media/apple.b5833d0a.svg";